var map = {
	"./iviis-logo.jpg": 128,
	"./marathon-targets-logo.jpg": 181,
	"./morse-micro-logo.jpg": 677,
	"./schneider-company-logo.jpg": 61,
	"./vidi-astra-logo.jpg": 14
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;